import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "controls-dock" }
const _hoisted_2 = { class: "dock-inner" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "icon-circle" }
const _hoisted_5 = {
  key: 0,
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  fill: "currentColor"
}
const _hoisted_6 = {
  key: 1,
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  fill: "currentColor"
}
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "icon-circle" }
const _hoisted_9 = {
  key: 0,
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  fill: "currentColor"
}
const _hoisted_10 = {
  key: 1,
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  fill: "currentColor"
}

interface Props {
  muted?: boolean;
  cameraOff?: boolean;
  showPipButton?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CallControls',
  props: {
    muted: { type: Boolean, default: false },
    cameraOff: { type: Boolean, default: false },
    showPipButton: { type: Boolean, default: true }
  },
  emits: ["toggle-mute", "toggle-camera", "toggle-pip", "end-call"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(["ctrl-btn", { 'is-off': _ctx.muted }]),
        title: _ctx.muted ? 'Ativar Som' : 'Mutar',
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-mute')))
      }, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.muted)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _cache[3] || (_cache[3] = [
                _createElementVNode("path", { d: "M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" }, null, -1),
                _createElementVNode("path", { d: "M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" }, null, -1)
              ])))
            : (_openBlock(), _createElementBlock("svg", _hoisted_6, _cache[4] || (_cache[4] = [
                _createElementVNode("path", { d: "M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.17l5.98 6zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .42-.03.62-.08l4.09 4.09c-.84.54-1.84.85-2.93.92V21h-2v-3.08c-3.39-.49-5.99-3.39-5.99-6.92H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c1.22-.18 2.36-.61 3.33-1.24l3.4 3.4L21 18.73 4.27 3z" }, null, -1)
              ])))
        ]),
        _createElementVNode("span", null, _toDisplayString(_ctx.muted ? "Ativar" : "Mutar"), 1)
      ], 10, _hoisted_3),
      _createElementVNode("button", {
        class: _normalizeClass(["ctrl-btn", { 'is-off': _ctx.cameraOff }]),
        title: _ctx.cameraOff ? 'Ligar Câmera' : 'Desligar Câmera',
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-camera')))
      }, [
        _createElementVNode("div", _hoisted_8, [
          (!_ctx.cameraOff)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _cache[5] || (_cache[5] = [
                _createElementVNode("path", { d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" }, null, -1)
              ])))
            : (_openBlock(), _createElementBlock("svg", _hoisted_10, _cache[6] || (_cache[6] = [
                _createElementVNode("path", { d: "M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z" }, null, -1)
              ])))
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("span", null, "Câmera", -1))
      ], 10, _hoisted_7),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "divider-v" }, null, -1)),
      _createElementVNode("button", {
        class: "ctrl-btn hangup",
        title: "Desligar",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('end-call')))
      }, _cache[8] || (_cache[8] = [
        _createElementVNode("div", { class: "icon-circle" }, [
          _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            width: "26",
            height: "26",
            fill: "currentColor"
          }, [
            _createElementVNode("path", { d: "M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08a.948.948 0 0 1-.29-.7c0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z" })
          ])
        ], -1),
        _createElementVNode("span", null, "Encerrar", -1)
      ]))
    ])
  ]))
}
}

})